import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

const isServerHiccup = (error) => error?.response?.status !== 404;

// The server can be unreachable for a few seconds (restart, new release): keep retrying and recover by itself.
const RESILIENT = {
  retry: (count, error) => isServerHiccup(error) && count < 6,
  retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 8000),
  refetchInterval: (query) => (query.state.status === "error" && isServerHiccup(query.state.error) ? 10_000 : false),
  refetchOnWindowFocus: (query) => query.state.status === "error",
};

export const useProducts = () =>
  useQuery({
    queryKey: ["products"],
    queryFn: async () => {
      const { data } = await api.get("/products");
      return Array.isArray(data) ? data : [];
    },
    ...RESILIENT,
  });

export const useProduct = (slug) =>
  useQuery({
    queryKey: ["product", slug],
    queryFn: async () => (await api.get(`/products/${slug}`)).data,
    enabled: Boolean(slug),
    ...RESILIENT,
  });

export const useStoreConfig = () => {
  const query = useQuery({
    queryKey: ["store-config"],
    queryFn: async () => (await api.get("/store/config")).data,
    staleTime: Infinity,
    ...RESILIENT,
  });
  return {
    threshold: query.data?.free_shipping_threshold ?? 45,
    shippingCost: query.data?.shipping_cost ?? 4.9,
  };
};
